import { twMerge } from "tailwind-merge";
import { WifiLow } from "lucide-react";
import type { ConnectionQuality } from "@core/features/video";

export type Props = {
  className?: string;
  connectionQuality: ConnectionQuality;
  isWithContentShare?: boolean;
};

export function VideoMeetingTileConnectionIcon({
  connectionQuality,
  className,
  isWithContentShare,
}: Props) {
  if (connectionQuality === "good") return null;

  const Icon = WifiLow;
  const iconSize = isWithContentShare ? 12 : 16;

  return (
    <div
      className={twMerge(
        "absolute top-1 right-1 px-1.5 py-1.5 rounded-md bg-brand-900/80 backdrop-blur",
        className,
      )}
    >
      <Icon
        size={iconSize}
        strokeWidth={2.5}
        className="text-brand-400 transition-all duration-100"
      />
    </div>
  );
}

export default VideoMeetingTileConnectionIcon;
